import { Component, Input, OnInit } from '@angular/core';
import { IMultiProductCard } from '@mwe/models';
import { isProductCategoryFernwaerme, isProductCategoryStromOrGas, sortProductsEnumCategory } from '@mwe/utils';
import { BasicCardBodylessComponent } from '../../cards/basic-card/basic-card-bodyless.component';

import { ProductIconComponent } from '../../product-icon/product-icon.component';
import { TranslateDirective } from '@ngx-translate/core';
import { CorrelatedCompanyReferencePipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-multi-product-card',
  templateUrl: './multi-product-card.component.html',
  styles: [],
  imports: [BasicCardBodylessComponent, ProductIconComponent, TranslateDirective, CorrelatedCompanyReferencePipe],
})
export class MultiProductCardComponent implements OnInit {
  @Input() card: IMultiProductCard;
  @Input() isDisabled = false;
  @Input() showCompanyReference = false;
  @Input() showSummarizedCompanyReference = false;
  @Input() showAccountNumber = false;
  @Input() showCustomerNumber = false;
  @Input() height100 = false;
  @Input() noBoxShadow = false;
  @Input() noRadiusBottom = false;

  ngOnInit(): void {
    if (this.card?.categories) {
      this.card.categories = sortProductsEnumCategory(this.card.categories, true);
    }
  }

  isAccountNumberVisible() {
    return this.showAccountNumber && this.card?.accountNumber && isProductCategoryStromOrGas(this.card?.categories?.[0]);
  }

  isCustomerNumberVisible() {
    return this.showCustomerNumber && this.card?.customerNumber && isProductCategoryFernwaerme(this.card?.categories?.[0]);
  }
}
